
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditCloth from '../EditCloth'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListClothRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditCloth, setModalEditCloth] = useState(false)
    const [clothId, setClothId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [clothName, setClothName] = useState("")

    async function deleteCloth(id) {
        let msgType = 'success'
        const data = await api.delete(`/cloth/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <span className='pg-item-name'>{item.name}</span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setClothId(item._id); setModalEditCloth(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setClothId(item._id); setClothName(item.name) }} />
                        }
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditCloth}
                changeStatus={setModalEditCloth}
                w={82}
                content={
                    <EditCloth id={clothId} handleOnSuccess={() => { setModalEditCloth(false); handleOnSuccess() }} btCancelAction={() => setModalEditCloth(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteCloth(clothId)}
                message="Deseja realmente excluir esse tecido?"
                itemName={clothName}
            />

        </div>
    )
}

export default ListClothRow
